<template>
  <div class="games">
    <div class="header">
      <StarIcon class="icon" />
      <h1 class="title">{{ i18n.playedRecently }}</h1>
    </div>
    <div class="contentWrapper">
      <div class="content">
        <div class="item"
             :key="game.tenantGameId"
             v-for="game in state.games"
             @click="selectGame(game)">
          <img class="thumb"
               v-if="game.thumbUrl"
               :src="game.thumbUrl"
               :alt="game.name" />
          <p v-else
             class="title">
            {{ game.displayName }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, inject } from 'vue';
import StarIcon from './StarIcon';

export default {
  name: 'Games',
  components: { StarIcon },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const i18n = inject('i18n');
    const state = reactive({
      games: props.data,
    });

    const selectGame = (game) => {
      window.parent.postMessage(
        {
          action: 'OpenGame',
          value: JSON.parse(JSON.stringify(game)),
        },
        '*',
      );
    };

    return {
      state,
      selectGame,
      i18n,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../style/scrollbar";

.games {
  padding-right: 30px;
  padding-left: 10px;

  .header {
    display: grid;
    justify-content: start;
    align-items: center;
    grid-template-columns: 26px auto;
    padding: 0 10px;
    padding-left: 0;

    .title {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .content {
    display: block;
    height: 100px;
    width: max-content;
    margin-bottom: 10px;
    padding: 10px 0;
  }

  .contentWrapper {
    display: block;
    width: 100%;
    height: inherit;
    overflow-x: auto;
    margin-bottom: 20px;
    @include scrollbar();
  }

  .item {
    display: grid;
    align-content: center;
    border-radius: 10px;
    float: left;
    width: 142px;
    height: 100px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2);
    margin-right: 10px;
    box-shadow: 1px 20px 40px -28px #8b2f61;
    -webkit-box-shadow: 1px 20px 40px -28px #8b2f61;
    -moz-box-shadow: 1px 20px 40px -28px #8b2f61;

    &:last-child {
      margin-right: 0;
    }
  }

  .thumb {
    width: 100%;
    height: inherit;
    max-height: 100%;
    object-fit: cover;
    border-radius: inherit;
    font-size: 0;
    pointer-events: none;
  }

  .title {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
  }
}
</style>
